import React, { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

import { Fade, Card, Switch } from "@mui/material";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

function Languages({ languages, showModal, signalCloseModal, setAvailableLanguages }) {
  const [open, setOpen] = useState(false);
  const [switchLanguages, setSwitchLanguages] = useState([]);
  const [filteredSwitchLanguages, setFilteredSwitchLanguages] = useState([]);
  const [lastSavedLanguages, setLastSavedLanguages] = useState([]);
  const [initSearch, setInitSearchValue] = useState("");
  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");

  const handleCancelChanges = () => {
    setOpen(false);
    signalCloseModal(false, null);
    if (lastSavedLanguages) {
      setSwitchLanguages(lastSavedLanguages);
      setFilteredSwitchLanguages(lastSavedLanguages);
    }
    setInitSearchValue("");
  };

  const handleChanges = () => {
    let tmpLanguages = [];
    let openedLanguages = [];

    switchLanguages.forEach((lang) => {
      if (!lang.checked) tmpLanguages.push(lang.name.toLowerCase());
      if (lang.checked) openedLanguages.push(lang.name.toLowerCase());
    });

    if (openedLanguages.length > 3) {
      setApiresponse("error");
      setApiResponseMsg("You cant select more than 3 languages to show.");
      setNotification(true);
      return;
    }

    setAvailableLanguages(tmpLanguages);
    setLastSavedLanguages(JSON.parse(JSON.stringify(switchLanguages)));
    setFilteredSwitchLanguages(JSON.parse(JSON.stringify(switchLanguages)));
    setInitSearchValue("");
    setOpen(false);
  };

  const handleLanguageChange = (e) => {
    let tmpLanguages = JSON.parse(JSON.stringify(switchLanguages));

    let item = tmpLanguages.find((lang) => lang.name == e.currentTarget.id.split("--switch")[0]);

    item.checked = !item.checked;

    setSwitchLanguages(tmpLanguages);

    tmpLanguages = tmpLanguages.filter((item) => item.name.indexOf(initSearch) > -1);

    setFilteredSwitchLanguages(tmpLanguages);
    //console.log(e);
  };

  const handleAllSelection = (event, status) => {
    event.preventDefault();
    setInitSearchValue("");

    let tmpLanguages = JSON.parse(JSON.stringify(switchLanguages));

    tmpLanguages.forEach((lang) => {
      lang.checked = status;
    });

    setSwitchLanguages(tmpLanguages);
    setFilteredSwitchLanguages(tmpLanguages);
  };

  const filterSwitchLanguages = (e) => {
    //console.log(e.currentTarget.value);
    setInitSearchValue(e.currentTarget.value);
    let tmpLanguages = JSON.parse(JSON.stringify(switchLanguages));

    tmpLanguages = tmpLanguages.filter((item) => item.name.indexOf(e.currentTarget.value) > -1);

    setFilteredSwitchLanguages(tmpLanguages);
    //console.log(tmpLanguages);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  useEffect(() => {
    if (open && showModal == false) {
      setSwitchLanguages(lastSavedLanguages);
      setFilteredSwitchLanguages(lastSavedLanguages);
    }
    setOpen(showModal);
  }, [showModal]);

  useEffect(() => {
    let tmpLanguages = [];
    languages.forEach((lang) => {
      tmpLanguages.push({ name: lang.name, checked: lang.checked });
    });
    setSwitchLanguages(tmpLanguages);
    setFilteredSwitchLanguages(tmpLanguages);
    setLastSavedLanguages(JSON.parse(JSON.stringify(tmpLanguages)));
  }, [languages]);

  return (
    <div
      style={{
        zIndex: showModal ? 10099 : -10000,
        position: "absolute",
        top: "180px",
        right: "50px",
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <Fade in={open}>
        <SoftBox my={1}>
          <Card style={{ boxShadow: "0rem 0.2rem 1rem 0.2rem rgba(0, 0, 0, 0.2)" }}>
            <SoftBox justifyContent="space-between" p={3}>
              <SoftTypography variant="h6" fontWeight="medium">
                Available Languages
              </SoftTypography>
              <SoftTypography
                variant="caption"
                fontSize="small"
                sx={{ color: "#34476780 !important" }}
              >
                ( select maximum 3 languages )
              </SoftTypography>
              <SoftBox
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                sx={{ marginTop: "30px", marginLeft: "50%" }}
              >
                <SoftInput
                  placeholder="Search..."
                  value={initSearch}
                  onChange={filterSwitchLanguages}
                ></SoftInput>
              </SoftBox>

              <hr style={{ color: "rgb(240, 240, 240)", marginTop: "5px" }}></hr>
              <SoftBox
                display="block"
                justifyContent="space-between"
                p={3}
                style={{
                  maxHeight: "350px !important",
                  overflow: "auto",
                  paddingTop: "5px",
                  paddingBottom: "0px",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  scrollbarWidth: "thin",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                {filteredSwitchLanguages.map((lang) => (
                  <SoftBox key={lang.name} display="flex" justifyContent="space-between" p={0}>
                    <SoftTypography variant="label" sx={{ fontSize: "1rem" }}>
                      {lang.name}
                    </SoftTypography>
                    <Switch
                      id={lang.name + "--switch"}
                      checked={lang.checked}
                      onChange={handleLanguageChange}
                    />
                  </SoftBox>
                ))}
              </SoftBox>
              <hr style={{ color: "rgb(240, 240, 240)" }}></hr>
              <SoftBox sx={{ display: "table", marginLeft: "auto" }} p={0}>
                <Button
                  className="letter-button error"
                  onClick={(e) => handleAllSelection(e, false)}
                >
                  Clear
                </Button>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between" alignItems="flex-end" p={3}>
                <Button onClick={handleCancelChanges}>Cancel</Button>
                <Button onClick={handleChanges}>Show</Button>
              </SoftBox>
            </SoftBox>
          </Card>
        </SoftBox>
      </Fade>
    </div>
  );
}

// Setting default values for the props of CreatePlatform
Languages.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreatePlatform
Languages.propTypes = {
  languages: PropTypes.array,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
  setAvailableLanguages: PropTypes.func,
};

export default Languages;
